import React from 'react'
import FooterInfoLayout from '@layouts/footer-info-layout'
import { TermsAndConditionsContent } from './terms-and-conditions'
import { ListItem, VStack, UnorderedList, Text } from '@chakra-ui/react'
import Link from 'next/link'

const FAQ = () => {
  return (
    <FooterInfoLayout title="Frequently Asked Question">
      <VStack w={'100%'} spacing={8}>
        {/* 1 */}
        <TermsAndConditionsContent title="How do I apply the discount code from the newsletter?">
          <TermsAndConditionsContent>
            To apply the discount code received from the newsletter, follow
            these steps:
          </TermsAndConditionsContent>
          <TermsAndConditionsContent>
            <UnorderedList pl={4}>
              <ListItem>Copy the code from the email.</ListItem>
              <ListItem>
                Paste the code in the discount code field in the cart.
              </ListItem>
              <ListItem>
                Click on "Apply" to apply the discount to your order. If it
                doesn't work, try removing all products from the cart, adding
                them back, and repeating the process.
              </ListItem>
            </UnorderedList>
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
        {/* 2 */}
        <TermsAndConditionsContent title="I confirmed my order but want to recheck my cart. Can I still apply the discount code?">
          <TermsAndConditionsContent>
            Once the order is confirmed and you proceed to the payment stage,
            the code is typically valid for one usage only. The code may no
            longer be active if you need to recheck your cart. Please contact
            our customer service to reactivate a new code for you.
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
        {/* 3 */}
        <TermsAndConditionsContent title="I placed an order but have yet to receive an order confirmation email. What should I do?">
          <TermsAndConditionsContent>
            If you've completed the full payment procedure and still haven't
            received the confirmation email, follow these steps:
          </TermsAndConditionsContent>
          <TermsAndConditionsContent>
            <UnorderedList pl={4}>
              <ListItem>
                Account User: Check your order history under your account.
              </ListItem>
              <ListItem>
                Anonymous/Guest Checkout: Ensure you've entered the correct
                email address and refresh your email to check. If unsure, don't
                hesitate to get in touch with us.
              </ListItem>
              <ListItem>
                If no payment was processed, the products in your cart should
                still be there. Please go ahead and make your payment again.
              </ListItem>
            </UnorderedList>
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
        {/* 4 */}
        <TermsAndConditionsContent title="I received an email confirmation for an order I didn't pay for. Will it be delivered?">
          <TermsAndConditionsContent>
            If no payment is processed, the order will be voided and ignored.
            You won't receive the products.
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
        {/* 5 */}
        <TermsAndConditionsContent title="Do you price match if I find a cheaper item on another site?">
          <TermsAndConditionsContent>
            While we offer competitive prices throughout the year, we cannot
            always guarantee price matching. However, we welcome your feedback,
            and if there's a considerable price difference, please contact us.
            Please be cautious of products without the JML/Habbit logo or from
            unauthorized sellers, as they may be counterfeit and potentially
            harmful.
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
        {/* 6 */}
        <TermsAndConditionsContent title="Are your product prices inclusive of GST?">
          <TermsAndConditionsContent>
            Yes, all our product prices include the prevailing GST as we're
            based in Singapore.
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
        {/* 7 */}
        <TermsAndConditionsContent title="How can I cancel my orders?">
          <TermsAndConditionsContent>
            To cancel your orders, please call our customer service hotline.
            Please note that JML Singapore Pte Ltd reserves the right to refund
            only the price of the Goods based on your mode of payment, even
            after the sales order is confirmed and payment has been received, in
            lieu of delivery or supply within one business day.
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
        {/* 8 */}
        <TermsAndConditionsContent title="What should I do if I receive damaged or incomplete goods?">
          <TermsAndConditionsContent>
            In the event of incomplete, defective, or damaged goods in transit,
            you are entitled to a replacement or exchange. Please visit our
            service centre during office hours (Monday to Friday, 9 am to 6 pm,
            avoid lunch time 1 pm - 2 pm). However, the exchange policy does not
            cover "hygiene" or perishable products that have been
            opened/unsealed/used or products on clearance discount.
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
        {/* 9 */}
        <TermsAndConditionsContent title="Who will bear the delivery cost of the replaced products?">
          <TermsAndConditionsContent>
            If you choose to exchange via courier, the cost of the courier will
            be borne by the customer.
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
        {/* 10 */}
        <TermsAndConditionsContent title="I'm new to Internet shopping and need assistance. How can I get help?">
          <TermsAndConditionsContent>
            Feel free to contact our friendly customer services team during
            working hours (Monday to Friday, 9 am to 6 pm, weekends 10 am to 3
            pm) for any assistance you need.
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
        {/* 11 */}
        <TermsAndConditionsContent title="I need help with purchasing items. What should I do?">
          <TermsAndConditionsContent>
            If you encounter problems with our site, it could be related to your
            web browser's security settings. Please ensure your security
            settings allow cookies, as our site uses them for features like the
            shopping cart. You can also add{' '}
            <Link
              href="https://www.jml.sg"
              target="_blank"
              style={{ textDecoration: 'underline' }}
            >
              www.jml.sg
            </Link>{' '}
            to your list of trusted sites. If you have any technical questions,
            please contact us.
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
        {/* 12 */}
        <TermsAndConditionsContent title="How can I share my feedback, comments, and suggestions?">
          <TermsAndConditionsContent>
            Please feel free to post your feedback, comments, and suggestions as
            long as they comply with our guidelines and policy. We reserve the
            right to remove or edit inappropriate content. If you share content,
            you grant JML Singapore Pte Ltd the right to use, reproduce, modify,
            adapt, publish, distribute, and display it worldwide. For any
            customer service-related feedback, email us with the required
            fields.
          </TermsAndConditionsContent>
          <TermsAndConditionsContent>
            <Text color="red">
              Note: Mobile and address details are optional and will only be
              used for direct replies. We ensure that your information is not
              disclosed to any third-party personnel.
            </Text>
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
      </VStack>
    </FooterInfoLayout>
  )
}

export default FAQ
